import type {
  FontSizesType,
  TFontWeight
} from '@/modules/perseo-billing/components/form/ui.interface';
import type { IPaymentMethod } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import type { IconTypes } from '@/modules/perseo-billing/ui/react/src';

export enum PaymentIconTypes {
  MASTER_CARD = 'MasterCard',
  VISA = 'Visa',
  AMEX = 'Amex',
  WEBPAY = 'Webpay',
  SCOTIA = 'Scotia'
}

export interface PaymentDetailProps {
  label: string;
  amount: string;
  labelWeight?: TFontWeight;
  labelSize?: FontSizesType;
  color?: string;
  primaryIcon?: IconTypes;
  secondaryIcon?: IconTypes;
}

export enum ECencoPayProcessorSubType {
  CencoPayCredit = 'CENCOPAY_CREDIT',
  CencoPayDebit = 'CENCOPAY_DEBIT',
  CencoPayCat = 'CENCOPAY_CAT',
  CencoPayPrepaid = 'CENCOPAY_PREPAID'
}

export const iconName: Record<PaymentIconTypes, IconTypes> = {
  MasterCard: 'MasterCardMyCard',
  Visa: 'VisaMyCard',
  Amex: 'CardAmericanExpressIcon',
  Webpay: 'WebPayCardIcon',
  Scotia: 'CencoScotiabankIcon'
};

export const cencoPayCardSubtitle: Record<ECencoPayProcessorSubType, string> = {
  [ECencoPayProcessorSubType.CencoPayCredit]: 'Crédito',
  [ECencoPayProcessorSubType.CencoPayDebit]: 'Débito',
  [ECencoPayProcessorSubType.CencoPayCat]: 'Crédito',
  [ECencoPayProcessorSubType.CencoPayPrepaid]: 'Prepago'
};

export interface IPaymentMethodCardPreview {
  paymentMethod?: IPaymentMethod;
  isCencoPayBalance?: boolean;
  isCencoPay?: boolean;
}
